import Vue from "vue";
import { ir } from "./check_domain_ir";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
import mixins from "./mixins";
import VueOffline from "vue-offline";
import "./registerServiceWorker";
// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
import ClipboardJS from "clipboard";
// Vue 3rd party plugins
import i18n, { onChangeLanguage } from "./i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/apexcharts";
import "@/core/plugins/treeselect";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import "./filters";
import { can } from "@/core/plugins/acl";

//Additional imports
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import DataTable from "laravel-vue-datatable";
import CKEditor from "@ckeditor/ckeditor5-vue2";
import Toast from "vue-toastification";
import "@fortawesome/fontawesome-free/js/all.js";
import "vue-toastification/dist/index.css";
//Global Plugins
import GlobalComponents from "./globalComponents";
import $ from "jquery";
import TerminalTitleRibbon from "./core/plugins/TitleRibbon/install";
import CustomPopup from "./core/plugins/TitleRibbon/plugins/popup/customPopup";
import CustomTabs from "./core/plugins/TitleRibbon/plugins/customTabs";
import VueTable from "./core/plugins/TitleRibbon/plugins/vueTable";
import {
  destroyToken,
  getToken,
} from "@/core/plugins/TitleRibbon/assets/js/jwt.service";
//MAP MATERIAL
import { LGeoJson, LMap, LMarker, LTileLayer } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";
import Typed from "typed.js";
import { LOGIN, LOGOUT } from "@/core/services/store/auth.module";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
require("@erfanrhb/erfan-editor");

let timer = null;
export const debounce = function (fn, delay) {
  clearTimeout(timer);
  timer = setTimeout(fn, delay);
};

Vue.use(VueOffline);
Vue.use(CKEditor);
Vue.use(VueSweetalert2);
Vue.use(GlobalComponents);
Vue.config.productionTip = false;
window.axios = require("axios");

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.headers["Authorization"] =
  "Bearer " + localStorage.getItem("id_token");

window.axios.interceptors.response.use(
  (response) => Promise.resolve(response),
  (error) => {
    if (error.response.status == 401) {
      localStorage.removeItem("id_token");
      router.push({ name: "login" });
    }
    return Promise.reject(error);
  }
);
Vue.prototype.$terminal = ir(".terminalads.com");
Vue.prototype.$coreApi3 = ir("https://api.terminalads.com");
Vue.prototype.$coreApi2 = ir("https://api.terminalads.com/api");
Vue.prototype.$coreApi = ir("https://core.terminalads.com");
Vue.prototype.$qrApi = ir("https://qr-api.terminalads.com/api");
Vue.prototype.$mediaApi = ir("https://media.terminalads.com");
Vue.prototype.$linkApi = ir("https://link.terminalads.com");
Vue.prototype.$robotApi = ir("https://robot-api.terminalads.com/api");
Vue.prototype.$payamakApi = ir("https://sms-api.terminalads.com/api");
Vue.prototype.$payamakApi2 = ir("https://sms-api.terminalads.com/api/");
Vue.prototype.$coreLogin = ir("https://core.terminalads.com/#/login");
Vue.prototype.$fileApi = ir("https://file-api.terminalads.com/api");
Vue.prototype.$fileApi2 = ir("https://file-api.terminalads.com/api/");
Vue.prototype.$corepayamakApi = ir("https://core-sms.terminalads.com");
Vue.prototype.$terminalads = ir("https://terminalads.com");
Vue.prototype.$coreqrOrigin = ir("core-qr.terminalads.com");
Vue.prototype.$robotCoreApi = ir("https://core-robot.terminalads.com");
Vue.prototype.$coreqrApi = ir("https://core-qr.terminalads.com");
Vue.prototype.$digiApi = ir("https://core-digi.terminalads.com");

Vue.prototype.$assets = {
  logo: ir(
    "https://api.terminalads.com/storage/s5wXoRhzyw9PkGXA8qnIL2yvA3TPiXhwsFrwjmeX.png"
  ),
};
Vue.prototype.$services = {
  1: ir("https://core.terminalads.com"),
  2: ir("https://core-sms.terminalads.com"),
  3: ir("https://core-qr.terminalads.com"),
  4: ir("https://core-robot.terminalads.com"),
  5: ir("https://core-billboard.terminalads.com"),
  10: ir("https://core-info.terminalads.com"),
  11: ir("https://core-file.terminalads.com"),
  13: ir("https://core-digi.terminalads.com"),
  14: ir("https://core-graphic.terminalads.com"),
};

window.$ = $;
Vue.use(DataTable);
window.PerfectScrollbar = PerfectScrollbar;
window.ClipboardJS = ClipboardJS;
Vue.prototype.$sarveLand = ir(process.env.VUE_APP_CoreLandUrl);
Vue.prototype.$sarveLandFront = ir("https://core.terminalads.com/#/login");
Vue.prototype.$smsUrl = ir(process.env.VUE_APP_SmsUrl);
Vue.prototype.$transportUrl = ir(process.env.VUE_APP_TransportUrl);
Vue.prototype.$billboardUrl = ir(process.env.VUE_APP_BillBoardUrl);
Vue.prototype.$showUrl = ir(process.env.VUE_APP_ShowUrl);
Vue.prototype.$qrlandshop = ir("https://core-sh.terminalads.com");
Vue.prototype.$qrUrl = ir(process.env.VUE_APP_QrUrl);
Vue.prototype.$digiUrl = ir(process.env.VUE_APP_DigiUrl);
Vue.prototype.$mediaUrl = ir(process.env.VUE_APP_MediaUrl);
Vue.prototype.$meliUrl = ir(process.env.VUE_APP_MeliUrl);
Vue.prototype.$robotUrl = ir(process.env.VUE_APP_RobotUrl);
Vue.prototype.$infoUrl = ir(process.env.VUE_APP_InfoUrl);
Vue.prototype.$requireLogin = ir(process.env.VUE_APP_isLoginRequired);
Vue.prototype.$secret = ir(process.env.VUE_APP_CoreSecret);
Vue.prototype.$fileUrl = ir(process.env.VUE_APP_FileUrl);
Vue.prototype.$graphicUrl = ir(process.env.VUE_APP_GraphicUrl);
Vue.prototype.$aiGenerator = ir("https://core-ai.terminalads.com");
Vue.prototype.$shortLink = ir("https://core-link.terminalads.com");
Vue.prototype.$coreWalletUrl = ir(process.env.VUE_APP_CoreWalletUrl);
Vue.prototype.$uploadUrl = ir(process.env.VUE_APP_CoreLandUrl + "/upload/");

Vue.use(DataTable);

Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);
Vue.component("l-marker", LGeoJson);
Vue.component("customPopup", CustomPopup);
Vue.component("customTabs", CustomTabs);
Vue.component("vueTable", VueTable);

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export const rbAxios = axios.create({
  baseURL: Vue.prototype.$robotApi,
  timeout: 15000,
  headers: {
    Authorization: localStorage.getItem("id_token"),
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});

export const qrAxios = axios.create({
  baseURL: Vue.prototype.$qrApi,
  timeout: 15000,
  headers: {
    Authorization: "Bearer " + localStorage.getItem("id_token"),
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
});
Vue.prototype.$ax = qrAxios;

Vue.use(Toast, {
  position: "top-center",
  timeout: 2000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: true,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: true,
  maxToasts: 1,
  newestOnTop: true,
  color: "black",
});
Vue.component("date-picker", VuePersianDatetimePicker);

Vue.use(TerminalTitleRibbon, {
  store,
  axios,
  config: () => ({
    dashboardConfig: {},
    static_top_menu: [],
    header_logo: Vue.prototype.$assets.logo,
  }),
  headers: {
    Authorization: "Bearer " + localStorage.getItem("id_token"),
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
  },
  permissions: () => window.Vue.$ability.j[0].actions,
  core_url: Vue.prototype.$sarveLand,
  front_url: Vue.prototype.$coreApi,
  sid: 1,
  onChangeLanguage,
});

Vue.use(mixins);
window.fillSubheaderText = async function (texts) {
  let options = {
    strings: texts,
    loop: true,
    typeSpeed: 50,
  };

  let el = window.document.querySelector("#bishin");

  while (!el) {
    await setTimeout(() => {}, 500);
    el = window.document.querySelector("#bishin");
  }

  let typed = new Typed("#bishin", options);
};

Vue.use(VueTelInput);

window.Vue = new Vue({
  data() {
    return {
      Loaded: 0,
      LoadCount: 2,
    };
  },
  methods: {
    fetch() {
      return new Promise((resolve, reject) => {
        try {
          if (getToken()) {
            // load abilities
            this.requestApiGet("abilitiesType")
              .then(({ data }) => {
                this.$ability.update([{ subject: "all", actions: data }]);
                this.addLoaded();
                resolve("resolved");
              })
              .catch(({ response }) => {
                console.log("failed to get ability type: ", reject("rejected"));
              });

            // check tocken and load user information
            this.checkTokenAsync(getToken()).then((res) => {
              this.addLoaded();
            });
          } else {
            reject("rejected");
          }
        } catch (e) {
          destroyToken();
          // window.Vue.goto('/login')
          reject("rejected");
        }
      });
    },
    setToken() {
      let url = window.location.href;
      const start = url.indexOf("?");
      const searchParams = new URL(window.location.href).search;

      const params = new URLSearchParams(searchParams);

      localStorage.removeItem("inviteCode");

      if (params.has("redirect_url")) {
        let redirectUrl = params.get("redirect_url").split("/#")[0];
        localStorage.setItem("redirect", redirectUrl);
      }
      if (start > -1) {
        this.requestApiGet("google/callback" + searchParams)
          .then(({ data }) => {
            if (data.status === 200) {
              store.dispatch(LOGOUT);
              store.dispatch(LOGIN, data.data.user);
              window.history.pushState("home", "Title", "/#/dashboard");
              router.push("/dashboard");
              return window.location.reload();
            }
            window.history.pushState("home", "Title", "/#/login");
            return this.$toast.error(data.message);
          })
          .catch((res) => {
            console.log("failed to login with google: ", res);
          });
      }
    },
    addLoaded() {
      this.Loaded++;
      if (this.Loaded >= this.LoadCount) {
        this.$store.dispatch("global/isLoaded", true);
      }
    },
    getLanguage() {
      const url = new URL(location.href);

      if (url.searchParams.has("lang"))
        onChangeLanguage(url.searchParams.get("lang"));
    },
  },
  async beforeMount() {
    this.setToken();
    const _this = this;

    function resolveNext(to, from, next) {
      if (
        !!to.query &&
        Object.hasOwn(to.query, "call_back_origin") &&
        Object.hasOwn(to.query, "call_back_hash")
      ) {
        window.location.href =
          to.query["call_back_origin"] +
          `/?token=${getToken()}#` +
          to.query["call_back_hash"];
      } else if (localStorage.getItem("redirect_origin") !== null) {
        const origin = localStorage.getItem("redirect_origin");
        const hash = localStorage.getItem("redirect_hash");

        localStorage.removeItem("redirect_origin");
        localStorage.removeItem("redirect_hash");

        window.location.href = `${origin}/?token=${getToken()}#${hash}`;
      } else if (
        (to.meta.permission && !can(to.meta.permission)) ||
        to.name === "login"
      ) {
        next({ name: "mainActivity" });
      } else {
        _this.setBreadcrumb(to.meta.title ?? "");
        next();
      }
    }

    router.beforeResolve((to, from, next) => {
      !store.getters["global/isLoaded"]
        ? this.fetch()
            .then(() => {
              resolveNext(to, from, next);
            })
            .catch(() => {
              if (to.name !== "login") next({ name: "login" });
              else next();
            })
        : resolveNext(to, from, next);
    });
  },
  mounted() {
    this.getLanguage();
  },
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
